module.exports = __webpack_public_path__ + "static/img/newsb.43b7277.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsb.png
// module id = oSSD
// module chunks = 45